import React from 'react'
import classes from "./Fourth.module.scss"
import img1 from "../../../assets/img/MainPage/4/1.jpg"

const Fourth = () => {
    return (
        <div className={[classes.fourth, ""].join(" ")}>
            <img src={img1} alt="" />
        </div>

    )
}

export default Fourth